// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import './assets/fa/iconfont.css'
import './assets/reset.css'
import g from './common/g.js'
import msgbox from './common/msgbox.js'
import { Button, Header, Tabbar, TabItem, Picker, Loadmore, DatetimePicker, Toast, Checklist, Actionsheet, Radio, Swipe, SwipeItem, CellSwipe } from 'mint-ui'
import 'mint-ui/lib/style.css'
import store from './store'
import config from './common/config'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.component(Button.name, Button)
Vue.component(Toast.name, Toast)
Vue.component(Header.name, Header)
Vue.component(Tabbar.name, Tabbar)
Vue.component(TabItem.name, TabItem)
Vue.component(Picker.name, Picker)
Vue.component(Loadmore.name, Loadmore)
Vue.component(Checklist.name, Checklist)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Actionsheet.name, Actionsheet)
Vue.component(Radio.name, Radio)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(CellSwipe.name, CellSwipe)

Vue.config.productionTip = false
Vue.prototype.$g = g
Vue.prototype.$msgboxs = msgbox

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  mounted () {
    let that = this
    let ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') > -1) {
      store().dispatch('getAuth')
      let path = window.location.href.split('#')
      if (store().state.auth.status !== 'in') {
        localStorage.setItem('url', path[1])
        if (path[1].split('=')[1].indexOf('&aid') > -1) {
          window.location.href = config.apiURI + 'users/createstate/' + path[1].split('=')[1].split('&')[0]
        } else {
          window.location.href = config.apiURI + 'users/createstate/' + path[1].split('=')[1]
        }
    }
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js